import {
    styled,
    Typography as MuiTypography,
    Card as MuiCard,
    CardContent as MuiCardContent,
} from "@mui/material";

export const Typography = styled(MuiTypography)((theme) => {
    return {
        lineHeight: "18px",
    };
});

export const Card = styled(MuiCard)(({ theme }) => {
    return {
        alignItems: "center",
        backgroundColor:
            theme.palette.mode === "dark"
                ? "#2E2D2C"
                : theme.palette.secondary.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "4px",
        cursor: "pointer",
        display: "inline-flex",
        height: "85px",
        width: "250px",
    };
});

export const CardContent = styled(MuiCardContent)((theme) => {
    return {
        padding: "0 8px",
        "&:last-child": { paddingBottom: 0 },
        textAlign: "start",
    };
});
